/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useContext } from 'react';
import { useStoreId, useConfigService } from '@thd-nucleus/experience-context';
import {
  useDataModel,
  QueryContext
} from '@thd-nucleus/data-sources';

const ruleMap = {
  QuestionsAndAnswersAccordionTitle: {
    expectedValue: true,
  },
  RatingsAndReviewsAccordionTitle: {
    expectedValue: true,
  }
};
const COMBO_EXPERIENCE_FEATURES = {
  questionsAndAnswers: true,
  ratingsAndReview: true,
};

const LAUNDRY_EXPERIENCE_FEATURES = {
  questionsAndAnswers: true,
  ratingsAndReview: true,
};

const KITCHEN_EXPERIENCE_FEATURES = {
  questionsAndAnswers: false,
  ratingsAndReview: false,
};

const feature = {
  default: COMBO_EXPERIENCE_FEATURES,
  laundry: LAUNDRY_EXPERIENCE_FEATURES,
  kitchen: KITCHEN_EXPERIENCE_FEATURES,
};

export function withDynamicBundleAccordion(BaseComponent, opts = {}) {

  function DynamicBundleAccordionRule(props) {

    const {
      renderRules: renderRulesProp = [],
      propRules: propRulesProp = {},
      componentDisplayName: _componentDisplayName,
      itemId
    } = props;

    const { defaultVariables } = useContext(QueryContext) || {};
    const storeId = useStoreId();
    const isCustomerIdentified = defaultVariables?.current?.isBrandPricingPolicyCompliant || false;

    const { data: productData } = useDataModel('product', {
      variables: {
        itemId,
        storeId,
        isBrandPricingPolicyCompliant: isCustomerIdentified
      },
      skip: !itemId
    });
    const configExperienceType = useConfigService('bundle-experience');
    const experienceType = configExperienceType || productData?.product?.bundleSpecificationDetails?.experienceType;

    const bundleExperienceFeatures = feature[experienceType] || feature.default;

    const {
      questionsAndAnswers: QuestionsAndAnswersAccordionTitle,
      ratingsAndReview: RatingsAndReviewsAccordionTitle,
    } = bundleExperienceFeatures || {};

    const values = {
      QuestionsAndAnswersAccordionTitle,
      RatingsAndReviewsAccordionTitle
    };

    const renderRules = [...renderRulesProp];

    const propRules = {
      ...propRulesProp
    };

    const processRender = (render) => {
      const mappedRule = ruleMap[render.name];
      if (render.name === _componentDisplayName && mappedRule) {
        const matchedValue = values[render.name] === mappedRule.expectedValue;
        renderRules.push(render.negate ? !matchedValue : matchedValue);
      }
    };

    if (opts.render) {
      if (Array.isArray(opts.render)) {
        opts.render.forEach(processRender);
      } else {
        processRender(opts.render);
      }
    }

    return (
      <BaseComponent {...props} renderRules={renderRules} propRules={propRules} />
    );

  }

  DynamicBundleAccordionRule.displayName = 'DynamicBundleAccordionRule';

  DynamicBundleAccordionRule.dataModel = {};

  return DynamicBundleAccordionRule;
}